import React, { useEffect, useMemo, useState } from "react";
import InnerBanner from "../Components/InnerBanner";
import BreadCrumb from "../Components/BreadCrumb";
import { useLocation } from "react-router-dom";
import { useGetFooterMenusDataQuery } from "../../../redux/services/internal/apiHome";
import { flattenMenus } from "../../../Utility/FlattenMenu";

const ScreenReader = ({ benchId }) => {
  const location = useLocation();
  const path = location.pathname;
  const menuPath = path.split("/").pop();

  const [filteredMenu, setFilteredMenu] = useState([]);

  // Fetch data from the API
  const { data: fetchedData = {}, isLoading } = useGetFooterMenusDataQuery(7);

  const menus = fetchedData?.data || [];

  const transformedData = useMemo(() => {
    return menus.length ? flattenMenus(menus) : [];
  }, [menus]);

  useEffect(() => {
    if (transformedData.length > 0) {
      const filtered = transformedData.filter((item) => item.slug === menuPath);
      setFilteredMenu(filtered);
    }
  }, [transformedData, menuPath]);

  const description = menus?.[6]?.description || "";

  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title={"Screen Reader"} />
        {description ? (
          <div dangerouslySetInnerHTML={{ __html: description }}></div>
        ) : (
          <p>No content available</p>
        )}
      </div>
    </>
  );
};

export default ScreenReader;
